// 客服工作台接口封装：登录复用后台登录接口，业务接口走 /yljx/admin/business/*。
import request, { setToken, setProfile, clearAuth, getProfile } from './request'

export const authApi = {
  async login (loginName, password) {
    const data = await request.post('/yljx/admin/auth/login', {
      login_name: loginName,
      password
    })
    setToken(data.token)
    setProfile(data.administrator)
    return data
  },
  logout () {
    try {
      request.post('/yljx/admin/auth/logout')
    } catch (e) { /* 忽略登出接口异常 */ }
    clearAuth()
  },
  profile () {
    return getProfile()
  }
}

export const selectionApi = {
  // params: { status, keyword }
  list: (params = {}) => request.get('/yljx/admin/business/user-data-selection', { params }),
  detail: (id) => request.get(`/yljx/admin/business/user-data-selection/${id}`),
  // payload: { type: '0'|'1'|'2', timerange?: '上午'|'下午'|'晚上'|'凌晨', actRange?: 'yyyy-MM-dd,yyyy-MM-dd' }
  // timerange / actRange 仅在客服调整了「用事时间段」「允许用事日期期限范围」时传入
  updateType: (id, payload) => request.post(`/yljx/admin/business/user-data-selection/${id}/type`, payload)
}
